import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {AppSettings} from "../app.settings";
import {Base2Service} from "./base2.service";
import {ResponseApi} from "./response/response";

@Injectable()
export class MeetingsService extends Base2Service {

    getMyMeetings():Observable<ResponseApi>{
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'meetings');
    }

    
    getClientMeetings(meetingId):Observable<ResponseApi>{
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + `meetings/client_meetings/${meetingId}`);
    }    

    getPersonMeetings(userId,personId):Observable<ResponseApi>{
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + `meetings/meetings_by_person/${userId}/${personId}`);
    }
    
    getClientInfo(meetingId):Observable<ResponseApi>{
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + `meetings/client_info/${meetingId}`);
    }

    getMeeting(id:number):Observable<ResponseApi>{
        return this.request<ResponseApi>("GET",AppSettings.apiUrl + `meetings/${id}`);
    }

    getMeetingsForComplete(userId):Observable<ResponseApi>{
        return this.request<ResponseApi>("GET",AppSettings.apiUrl + `meetings/need_result/${userId}`);
    }

    getMeetingsForConfirm(filter):Observable<ResponseApi>{
        return this.request<ResponseApi>("POST",AppSettings.apiUrl + `meetings/in_processing`,filter);
    }

    getMeetingsByFilter(filter):Observable<ResponseApi>{
        return this.request<ResponseApi>("POST",AppSettings.apiUrl + `meetings/filter`,filter);
    }

    getMeetingsByFilterDate(filter):Observable<ResponseApi>{
        return this.request<ResponseApi>("POST",AppSettings.apiUrl + `meetings/filterDate`,filter);
    }

    createMeeting(meeting:any):Observable<ResponseApi>{
        return this.request<ResponseApi>("POST",AppSettings.apiUrl + 'meetings',meeting)
    }

    updateMeeting(meeting:any):Observable<ResponseApi>{
        return this.request<ResponseApi>("PUT",AppSettings.apiUrl + `meetings/${meeting.Id}`,meeting)
    }

    confirmMeeting(id:number){
        return this.request<ResponseApi>("PUT",AppSettings.apiUrl + `meetings/confirm/${id}`)
    }
    
    getMeetingsByFilterLink(filter):Observable<ResponseApi>{
        return this.request<ResponseApi>("POST",AppSettings.apiUrl + `meetings/filterLink`,filter);
    }

    getMeetingsByFilterLinkMeetings(filter):Observable<ResponseApi>{
        return this.request<ResponseApi>("POST",AppSettings.apiUrl + `meetings/filterLinkS`,filter);
    }

    getMeetingsByFilterMeetings(filter):Observable<ResponseApi>{
        return this.request<ResponseApi>("POST",AppSettings.apiUrl + `meetings/filterMeetings`,filter);
    }

}